var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlaceholderImageStack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61.875,
    height: 60.06,
    viewBox: "0 0 61.875 60.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_45091",
    "data-name": "Group 45091",
    transform: "translate(0.502 0.512)",
    opacity: 0.813
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76034",
    "data-name": "Path 76034",
    d: "M74.16,48.04l-45.147,6.1a1.2,1.2,0,0,1-1.352-1.03l-6.1-45.147a1.2,1.2,0,0,1,1.03-1.352L67.735.51a1.2,1.2,0,0,1,1.352,1.031l6.1,45.147A1.2,1.2,0,0,1,74.16,48.04Z",
    transform: "translate(-21.548 -0.5)",
    fill: "none",
    stroke: "#848790",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76035",
    "data-name": "Path 76035",
    d: "M71.65,45.962,29.885,51.607a1.171,1.171,0,0,1-1.318-1L22.921,8.838a1.172,1.172,0,0,1,1-1.318L65.69,1.875a1.172,1.172,0,0,1,1.318,1l5.645,41.764a1.17,1.17,0,0,1-1,1.318",
    transform: "translate(-21.016 0.14)",
    fill: "#cbcdd5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76037",
    "data-name": "Path 76037",
    d: "M78.554,59.937,33.1,56.873a1.2,1.2,0,0,1-1.119-1.281l3.065-45.454a1.2,1.2,0,0,1,1.28-1.119l45.455,3.065A1.2,1.2,0,0,1,82.9,13.365L79.835,58.819A1.2,1.2,0,0,1,78.554,59.937Z",
    transform: "translate(-22.032 -0.895)",
    fill: "#fff",
    stroke: "#848790",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76039",
    "data-name": "Path 76039",
    d: "M75.53,49.739l-36.787-2.48a1.2,1.2,0,0,1-1.119-1.281l2.113-31.339a1.2,1.2,0,0,1,1.281-1.119L77.805,16a1.2,1.2,0,0,1,1.118,1.281L76.811,48.621A1.2,1.2,0,0,1,75.53,49.739Z",
    transform: "translate(-22.294 -1.104)",
    fill: "none",
    stroke: "#848790",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76041",
    "data-name": "Path 76041",
    d: "M49.785,22.485a3.329,3.329,0,1,1-3.1-3.546A3.329,3.329,0,0,1,49.785,22.485Z",
    transform: "translate(-21.953 -0.759)",
    fill: "none",
    stroke: "#848790",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76042",
    "data-name": "Path 76042",
    d: "M72.129,41.73a.417.417,0,0,0-.046-.221L65.756,29.455a1.013,1.013,0,0,0-1.567-.3l-8,6.989a1.424,1.424,0,0,1-2.009-.135L51.6,33.06a1.426,1.426,0,0,0-2.029-.119L42.4,39.43a.409.409,0,0,0-.135.277l-.256,3.8a.41.41,0,0,0,.382.437l29.023,1.957a.411.411,0,0,0,.437-.381Z",
    transform: "translate(-20.829 -1.146)",
    fill: "#cbcdd5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76043",
    "data-name": "Path 76043",
    d: "M41.633,38.48l7.6-6.881a1.014,1.014,0,0,1,1.443.084L53.8,35.257a1.013,1.013,0,0,0,1.429.1l8.31-7.259a1.013,1.013,0,0,1,1.567.3l6.276,12.172",
    transform: "translate(-21.45 -1.017)",
    fill: "none",
    stroke: "#848790",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderImageStack);
export default __webpack_public_path__ + "static/media/placeholder-image-stack.0a8acc73d28137533ad4ea3dd3a646d0.svg";
export { ForwardRef as ReactComponent };